import React from "react";
import "./Reward.css";
import reward from "../../../../new_images/Landing/Icons/Icon_inicio_trofeo.png";

class Reward extends React.Component {
  render() {
    return (
      <section>
        <div className="reward_container">
          <div className="col col-lg-12 col-md-12 col-sm-12 col-xs-12 reward">
            <div className="reward_header"></div>
            <div className="reward_body">
              <img className="reward_image" src={reward} alt="reward" />

              <p className="reward_title">Gana recompensas únicas</p>

              <p className="reward_subtitle">
                Se libre de compartir viajes con gente que comparte un mismo
                destino
              </p>

              <p className="reward_description">
                Tovo te brinda la posibilidad de compartir viajes con personas
                de tu trabajo, universidad, familia, entre otros.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Reward;
